module.exports = __webpack_public_path__ + "static/media/iconLibraryNumericActive.60f8f4ba.svg";